import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss'

function Timeline() {
  return (
    <div id="history">
      <div className="items-container">
        <h1>Career History</h1>
        <VerticalTimeline>
          
          {/* JamboPay - Senior Software Engineer */}
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid white' }}
            date="03/2022 - Present"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Senior Software Engineer</h3>
            <h4 className="vertical-timeline-element-subtitle">JamboPay | Nairobi, Kenya</h4>
            <p>
              Backend financial services, e-wallet platform redesign (90% throughput improvement), 
              RESTful APIs for Uber Kenya, E-Citizen & Kenya Ports Authority, 99% uptime maintenance, 
              mentoring junior developers, Agile (Scrum) delivery
            </p>
          </VerticalTimelineElement>

          {/* ICEA LION Insurance - Software Engineer */}
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="11/2020 - 03/2022"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Software Engineer</h3>
            <h4 className="vertical-timeline-element-subtitle">ICEA LION Insurance | Nairobi, Kenya</h4>
            <p>
              Backend systems for insurance policy management, customer self-service platforms,
              MS SQL Server query optimization, WhatsApp chatbot integration, 
              Agile collaboration, enterprise system modernization
            </p>
          </VerticalTimelineElement>

          {/* Centrino Technologies - Junior Developer */}
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="03/2020 - 09/2020"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Junior Developer</h3>
            <h4 className="vertical-timeline-element-subtitle">Centrino Technologies | Nairobi, Kenya</h4>
            <p>
              Backend features for core banking systems, payment gateway integration,
              transaction monitoring dashboards, enterprise development practices,
              version control, production support
            </p>
          </VerticalTimelineElement>

          {/* IntSoft Kenya - Junior Developer */}
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="08/2019 - 01/2020"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Junior Developer</h3>
            <h4 className="vertical-timeline-element-subtitle">IntSoft Kenya | Nairobi, Kenya</h4>
            <p>
              Backend modules for County Government Management System, bug fixes,
              database optimizations, system reliability improvements, government service delivery
            </p>
          </VerticalTimelineElement>

        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;